module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Light-Italic.510fc2f0.ttf";